import Vue from 'vue'
import Router from 'vue-router'
import {
  BASEURL
} from '@/utils/common/config'
import login from '@/view/login/login'

// 获取权限，阻止跨角色
import {
  post
} from "@/utils/api/router";
const url = BASEURL + 'admin/menu/index'
var auth = []

post(url, '').then(res => {
  // console.log(res.data);
  for (let i = 0; i < res.data.length; i++) {
    auth.push(res.data[i].router_path)
    if (res.data[i].children) {
      for (let k = 0; k < res.data[i].children.length; k++) {
        auth.push(res.data[i].children[k].router_path)
      }
    }

  }
  auth.push('/404')
  auth.push('/')
  // console.log(auth);
})



Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  // mode: 'history',
  routes: [{
      // 404 没有的路由全部跳转404
      path: '*',
      name: 'error',
      component: () => import('@/view/404/404.vue'),
    },
    {
      // 404 没有的路由全部跳转404
      path: '/404',
      name: '404',
      component: () => import('@/view/404/404.vue'),
    },
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      // 首页
      path: '/home',
      name: 'home',
      component: () => import('@/view/home/home.vue'),
      meta: {
        requireAuth: true,
        ue: true
      },
      redirect: '/home/index',
      children: [{
          path: 'index',
          name: 'index',
          component: () => import('@/view/index/index.vue'),
        },
        {
          path: 'a',
          name: 'a',
          component: () => import('@/view/test/a.vue'),
        },
        {
          // 设置模块
          path: 'set_mods',
          name: 'set_mods',
          component: () => import('@/view/set/set_mods/set_mods.vue'),
        },
        {
          // 用户管理
          path: 'set_user',
          name: 'set_user',
          component: () => import('@/view/set/set_user/set_user.vue'),
        },
        {
          // 角色管理
          path: 'set_admin',
          name: 'set_admin',
          component: () => import('@/view/set/set_admin/set_admin.vue'),
        },
        {
          // 主题
          path: 'theme',
          name: 'theme',
          component: () => import('@/view/System-settings/theme/theme.vue')
        },
        {
          // ip登录日志
          path: 'journal',
          name: 'journal',
          component: () => import('@/view/System-settings/journal/journal.vue')
        },
        {
          // ip登录日志
          path: 'help',
          name: 'help',
          component: () => import('@/view/System-settings/help/help.vue')
        },
        {
          // 关于我们 about
          path: 'about',
          name: 'about',
          component: () => import('@/view/about/about.vue')
        }, {
          // 公告列表 notice
          path: 'notice',
          name: 'notice',
          component: () => import('@/view/System-settings/notice/notice.vue')
        },
        // 系统配置-----》》end
        //  ---------------------------------------------------


        // 页面配置 start---------------
        // ============================================
        {
          // 订单列表
          path: 'order',
          name: 'order',
          component: () => import('@/view/order/order.vue')
        },
        {
          // 商品列表
          path: 'goods',
          name: 'goods',
          component: () => import('@/view/integral-mall/goods/goods.vue')
        },
        {
          // 活动规则
          path: 'rule',
          name: 'rule',
          component: () => import('@/view/rule/rule.vue')
        },
        {
          // 积分兑换记录
          path: 'exchange_record',
          name: 'exchange_record',
          component: () => import('@/view/integral-mall/integral-log/integral-log.vue')
        },
        {
          // 垃圾分类大作战---垃圾
          path: 'garbage',
          name: 'garbage',
          component: () => import('@/view/garbage-game/garbage/garbage.vue')
        },
        {
          // 垃圾分类大作战---垃圾桶
          path: 'Trash',
          name: 'Trash',
          component: () => import('@/view/garbage-game/Trash/Trash.vue')
        },
  
        
        {
          // 百科资讯
          path: 'Encyclopedia',
          name: 'Encyclopedia',
          component: () => import('@/view/Encyclopedia/Encyclopedia.vue')
        },
        {
          // 用户管理
          path: 'user',
          name: 'user',
          component: () => import('@/view/user/user.vue')
        },

        {
          // 广告管理 advertisement
          path: 'advertisement',
          name: 'advertisement',
          component: () => import('@/view/advertisement/advertisement.vue')
        },

        {
          // 直播
          path: 'live-broadcast',
          name: 'live-broadcast',
          component: () => import('@/view/live-broadcast/live-broadcast.vue')
        },
    
        {
          // 分享配置
          path: 'share',
          name: 'share',
          component: () => import('@/view/share/share.vue')
        },
        // ------->>>>
        {
          // 测富文本 edit 
          path: 'edit',
          name: 'edit',
          component: () => import('@/components/edit/test.vue')
        },
        {
          //预约时间
          path: 'appointment_time',
          name: 'appointment_time',
          component: () => import('@/view/integral-mall/appointment_time/appointment_time.vue')
        },
        {
          //服务类型
          path: 'service',
          name: 'service',
          component: () => import('@/view/service/service.vue')
        },
        {
          //维修订单
          path: 'repair_list',
          name: 'repair_list',
          component: () => import('@/view/order/repair_list.vue')
        },
        {
          //客户
          path: 'customer',
          name: 'customer',
          component: () => import('@/view/customer/customer.vue')
        },
      ]
    }
  ]
})

router.afterEach((to, from, next) => {
  // // 重置body滚动条
  // document.querySelector('body').style.overflowY = 'auto';
  // // 防止页面回跳
  // if (from.path == '/about/') {

  // } else {
  // 	window.scrollTo(0, 0);
  // }

})

router.beforeEach((to, from, next) => {
  // 自动登录
  if (to.path == '/') {
    if (window.localStorage.token) {
      next({
        path: '/home'
      })
    }
  }

  if (auth.length != 0) {
    if (auth.indexOf(to.path) == -1) {
      next({
        path: '/404'
      })
    }
  }

  // if (to.query.token) {
  // 	window.localStorage.token = to.query.token
  // }
  // if (to.meta.requireAuth) {
  // 	//是否是需要权限的页面
  // 	if (token != '') {
  // 		next()
  // 	} else {
  // 		next({
  // 			path: '/'
  // 		})
  // 	}
  // } else {
  // 	//不需要权限的页面
  // 	next()
  // }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js